import Virgil from "./Virgil-Regular.woff2";

import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

export const VirgilFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: Virgil,
  },
];
